/**
 * 业务中用得到的路由名
 */
export enum PageEnum {
    ROOT = 'Root',
    /**
     * 主页
     */
    HOME = 'Home',
    /**
     * 封面
     */
    COVER = 'Cover',
    /**
     * 扫一扫，只用于埋点，无实际页面
     */
    SCAN = 'Scan',
    /**
     * 杯子页，只用于埋点，无实际页面
     */
    CUP = 'Cup',
    /**
     * 显微镜页，只用于埋点，无实际页面
     */    
    MICRO = 'Micro',
    /**
     * 球展示页，只用于埋点，无实际页面
     */    
    BALL = 'Ball',
    /**
     * 对比页，只用于埋点，无实际页面
     */
    COMPARE = 'Compare',
    /**
     * 404 页面
     */
    PAGE_NOT_FOUND = '404',
    /**
     * 重定向
     */
    REDIRECT = 'Redirect',
    /**
     * svg 页面
     */
    SVG = 'SVGPreview',
}